import(/* webpackMode: "eager" */ "/vercel/path0/src/app/time-clock/page.tsx");
